import tempMeeApi from '../../../apis/tempMee';
import { CandidateStatus } from '../enums/CandidateStatus';

// Recruitment service expects `app_expired` rather than the bare `expired`
// value returned on read. Other statuses are sent verbatim.
const outboundStatusMap = {
  [CandidateStatus.EXPIRED]: 'app_expired',
};

/**
 * Update candidate status
 *
 * @param {import('../types/UpdateCandidateStatus.parameters').IUpdateCandidateStatusPayload} payload - Request payload
 * @returns {Promise<void>} No content response
 */
export const updateCandidateStatus = async ({ candidateIds, status }) => {
  const outboundStatus = outboundStatusMap[status] ?? status;
  await tempMeeApi.patch(
    '/recruitment-service/admin/candidates/statuses',
    { candidateIds, status: outboundStatus },
  );
};
